import type { TDeployment, TStageEnvironment } from './deployments.types.ts';

export const deployments: Record<TStageEnvironment, TDeployment> = {
  local: {
    apiUrl: 'https://api.gocascade.devenv',
    llmUrl: 'https://llm.gocascade.devenv',
  },
  development: {
    apiUrl: 'https://api.gocascade-dev.ai',
    llmUrl: 'https://llm.gocascade-dev.ai',
  },
  production: {
    apiUrl: 'https://api.gocascade.ai',
    llmUrl: 'https://llm.gocascade.ai',
  },
};
